<template>
  <div class="relative bg-[#FF5A5B] min-w-[39px] max-w-[39px] min-h-[39px] max-h-[39px] rounded-full">
    <slot />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "CoralCircle",
});
</script>
